import { array, enums, literal, object, string } from "superstruct";

import { Permission } from "@mpa/platform/enums/Permission";

import type { PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import getEnumValues from "../enums/getEnumValues.js";
import { type User, UserDetailSchema, UserListItemSchema } from "../models/User.js";

export default function buildUserRouter(base: EndpointRouter<PathParamsBase, { user: User }>) {
    const router = base.addRouter(new EndpointRouter());

    const endpoints = {
        getUsersEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/users", object({}))
                .setResultParser(array(UserListItemSchema)),
        ),
        getUserEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/users/:user", object({ user: string() }))
                .setResultParser(UserDetailSchema),
        ),
        deleteUserEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("DELETE")
                .setPath("/users/:user", object({ user: string() }))
                .setResultParser(literal(null)),
        ),
        invalidateUserLoginsEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("DELETE")
                .setPath("/users/:user/logins", object({ user: string() }))
                .setResultParser(literal(null)),
        ),
        invalidateUserLoginEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("DELETE")
                .setPath("/users/:user/logins/:login", object({ user: string(), login: string() }))
                .setResultParser(literal(null)),
        ),
        updateUserEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("PUT")
                .setPath("/users/:user", object({ user: string() }))
                .setResultParser(literal(null))
                .setBodySchema(object({ permissions: array(enums(getEnumValues(Permission))) })),
        ),
        deleteUserProjectEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("DELETE")
                .setPath(
                    "/users/:user/projets/:projet",
                    object({ user: string(), projet: string() }),
                )
                .setResultParser(literal(null)),
        ),
        detachUserProjectEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("DELETE")
                .setPath(
                    "/users/:user/projets/:projet/candidate",
                    object({ user: string(), projet: string() }),
                )
                .setResultParser(literal(null)),
        ),
        deleteProjectEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("DELETE")
                .setPath("/projets/:projet", object({ projet: string() }))
                .setResultParser(literal(null)),
        ),
    };

    return { router, endpoints };
}
